import { render, staticRenderFns } from "./Collapse.vue?vue&type=template&id=34efc712&scoped=true&"
import script from "./Collapse.vue?vue&type=script&lang=js&"
export * from "./Collapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34efc712",
  null
  
)

export default component.exports